
import React, { useEffect } from 'react';
import { Rental } from '@/services/types';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { EditRentalForm } from './EditRentalForm';

interface EditRentalDialogProps {
  rental: Rental;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: any) => Promise<boolean>;
  loading: boolean;
  bikes: any[];
  couriers: any[];
  setIsFormOpen?: (isOpen: boolean) => void;
}

export const EditRentalDialog: React.FC<EditRentalDialogProps> = ({
  rental,
  open,
  onOpenChange,
  onSubmit,
  loading,
  bikes,
  couriers,
  setIsFormOpen
}) => {
  // Уведомляем родительский компонент об открытии/закрытии формы
  useEffect(() => {
    if (setIsFormOpen) {
      setIsFormOpen(open);
    }
  }, [open, setIsFormOpen]);
  
  // Обработчик отключения повторных запросов при открытии формы
  const handleOpenChange = (isOpen: boolean) => {
    onOpenChange(isOpen);
    if (setIsFormOpen) {
      setIsFormOpen(isOpen);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Редактировать аренду</DialogTitle>
        </DialogHeader>
        <EditRentalForm
          rental={rental}
          onSubmit={onSubmit}
          loading={loading}
          bikes={bikes}
          couriers={couriers}
        />
      </DialogContent>
    </Dialog>
  );
};
